import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/profile/requestTypes'
import { profileKeys } from '@core/react-query/features/profile/profileKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { organisationKeys } from '@core/react-query/features/organisations/organisation'

export const useUpdateProfile = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['updateProfile']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...profileKeys.updateProfile,
    // We don't retry mutations since they're not idempotent
    // We can allow retries if we implement idempotency keys and idempotency checking on the back-end
    retry: 0,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(profileKeys.profile.queryKey, {})
      if (variables.organisationId && variables.userId) {
        queryClient.invalidateQueries(
          organisationKeys
            .byId({
              organisationId: variables.organisationId,
            })
            ._ctx.organisationUser({
              userId: variables.userId,
            }),
          {},
        )
      }
    },
    ...options,
  })
}
